/**
 * API-клиент каталога отчётов (партнёрский).
 *
 * Отдельный от chatApi модуль: работает с REST-эндпоинтами amportal
 * `/api/reports/*` (список доступных отчётов, предпросмотр, асинхронная
 * выгрузка XLSX/CSV через очередь, скачивание по presigned URL).
 */
const BASE_URL = process.env.VUE_APP_URL_DEV || 'http://localhost:8080'

function authHeaders(extra = {}) {
    const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : ''
    return {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...extra,
    }
}

async function jsonFetch(url, options = {}) {
    const response = await fetch(url, {
        ...options,
        headers: authHeaders(options.headers || {}),
    })
    const data = await response.json().catch(() => ({}))
    if (!response.ok) {
        const error = new Error(data?.message || `Request failed: ${response.status}`)
        error.status = response.status
        error.payload = data
        throw error
    }
    return data
}

/**
 * Список доступных пользователю отчётов.
 * @returns {Promise<{items: Array<object>, planExpired: boolean}>}
 */
export async function listReports() {
    const data = await jsonFetch(`${BASE_URL}/api/reports`)
    return {
        items: Array.isArray(data?.items) ? data.items : [],
        planExpired: Boolean(data?.plan_expired),
    }
}

/**
 * Лёгкий предпросмотр отчёта (заголовки + первые строки).
 */
export async function previewReport(id, { limit = 50, params = {} } = {}) {
    const query = new URLSearchParams({ limit: String(limit) })
    if (params && Object.keys(params).length) {
        query.set('params', JSON.stringify(params))
    }
    return jsonFetch(`${BASE_URL}/api/reports/${id}/preview?${query.toString()}`)
}

/**
 * Поставить в очередь генерацию выгрузки. Возвращает { run_id, status }.
 */
export async function enqueueReportRun(id, { format = 'xlsx', params = {} } = {}) {
    return jsonFetch(`${BASE_URL}/api/reports/${id}/run`, {
        method: 'POST',
        body: JSON.stringify({ format, params }),
    })
}

/**
 * Список последних запусков (опц. по отчёту).
 */
export async function listReportRuns({ reportId } = {}) {
    const query = reportId ? `?report_id=${reportId}` : ''
    const data = await jsonFetch(`${BASE_URL}/api/reports/runs${query}`)
    return Array.isArray(data?.items) ? data.items : []
}

/**
 * Получить presigned URL готовой выгрузки.
 */
export async function getReportRunDownloadUrl(runId) {
    return jsonFetch(`${BASE_URL}/api/reports/runs/${runId}/download`)
}
